import type { ReactNode } from 'react'

import cn from 'clsx'
import { Image } from '@/components/image/image'
import { Text } from '@/components/Text/Text'

import sparkleTodoist from './sparkle-todoist.png'
import sparkleTwist from './sparkle-twist.png'

import css from './PromoBanner.module.css'

export interface PromoBannerProps {
    children: ReactNode
    theme?: 'todoist' | 'twist'
}

export function PromoBanner({ children, theme = 'todoist' }: PromoBannerProps) {
    return (
        <div
            className={cn(css.bannerContainer, {
                [css.todoist]: theme === 'todoist',
                [css.twist]: theme === 'twist',
            })}
        >
            <div className={css.icon}>
                <Image
                    src={theme === 'todoist' ? sparkleTodoist : sparkleTwist}
                    width={40}
                    height={40}
                    alt=""
                />
            </div>
            <Text tag="div" size="body-sm">
                {children}
            </Text>
        </div>
    )
}
